import _ from 'lodash'
import Serializer from './serializer.js'

export default class History {
  constructor () {
    this.evaluatedFormulas = {}
    this.history = []

    this.serializer = new Serializer()
  }

  removeAnnotations (formula) {
    return _.replace(formula, /#[^:]+:/g, '')
  }

  resolveComparableFormula (formula) {
    return _.trim(this.serializer.trim(this.removeAnnotations(formula)), '!')
  }

  shouldAdd (formula, result, nodeType) {
    const re = /secret/i

    return formula && !_.isFunction(result) && !_.has(this.evaluatedFormulas, [formula]) && (!_.includes([
      'Literal',
      'LogicalExpression',
      'Property',
      'ObjectExpression',
      'ArrayExpression',
      'TemplateElement'
    ], nodeType) || _.includes(['true', 'false'], _.toLower(formula))) && !re.test(formula) && !re.test(JSON.stringify(result))
  }

  addEntry (formula, result, nodeType) {
    if (this.shouldAdd(formula, result, nodeType)) {
      const entry = this.buildEntry(
        formula,
        result,
        false
      )

      const last = _.last(this.history)
      const comparableLastFormula = this.resolveComparableFormula(last?.formula)
      const comparableFormula = this.resolveComparableFormula(entry?.formula)

      if (comparableLastFormula === comparableFormula) {
        this.history.pop()
        entry.evaluatedFormula = last?.evaluatedFormula || entry.evaluatedFormula
      }

      this.history.push(entry)

      _.set(this.evaluatedFormulas, [formula], result)

      return entry
    }
  }

  buildEntry (formula, result, showHistory = true) {
    const resolvedFormula = this.serializer.trim(formula)
    const evaluatedFormula = this.#getEvaluatedFormula(resolvedFormula)

    return {
      formula: resolvedFormula,
      result,
      ..._.chain({
        evaluatedFormula: evaluatedFormula !== resolvedFormula && evaluatedFormula,
        history: showHistory && _.cloneDeep(this.history)
      }).pickBy().omitBy(_.isEmpty).value()
    }
  }

  #getEvaluatedFormula (formula) {
    return _.chain(this.evaluatedFormulas).map((er, ef) => ({
      ef,
      er
    })).sortBy(
      v => _.size(v.ef)
    ).reverse().reduce(
      (r, v) => _.isPlainObject(v.er) ? r : r.replaceAll(v.ef, this.serializer.serializeResult(v.er)),
      formula
    ).value()
  }
}
